<template lang="pug">
  div#appCentral(v-if="configLoading")
    vue-progress-bar
    div(
      v-if="loader.status"
      v-loading="loader.status",
      :element-loading-text="loader.text",
      v-loading.fullscreen.lock="true"
    )
    header
      main-header(
        :notificacao="false"
        :hasListagemModelo="false"
      )
    main.container
        side-menu.side-menu(v-if="!$route.meta.hideSideMenu")
        .content
          router-view
</template>

<script>
import { mapState } from 'vuex'
import MainHeader from '@/components/MainHeader'
import SideMenu from '@/components/SideMenu'

export default {
  components: {
    MainHeader,
    SideMenu
  },

  data () {
    return {
      configLoading: true // colocando true enquanto não há login
    }
  },

  computed: {
    ...mapState({
      loader: state => state.loader
    })
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/_variables.scss";

* {
  box-sizing: border-box;
  font-family: "Ubuntu", sans-serif;
}

header {
  width: 100%;
  position: fixed;
  z-index: 1000;
}

main.modal-open {
  overflow-x: hidden;
  position: relative;
  z-index: 8;
}

#appCentral {
  width: 100%;
  height: 100%;

  /deep/ h1,
  /deep/ h2,
  /deep/ h3,
  /deep/ h4,
  /deep/ h5,

  /deep/ p {
    margin: 0 0 10px;
  }

  .container {
    display: flex;
    border-radius: 12px;
    width: 100%;
  }

  .content {
    width: 100%;
    overflow-x: hidden;
    padding: 60px 0 0 150px;
  }

  .side-menu {
    position: fixed;
    top: 55px;
  }

  @media (max-width: 780px) {
   .side-menu {
    position: fixed;
    top: 128px;
    width: 35px;
   }
  }

}
</style>



// WEBPACK FOOTER //
// src/screens/central/MainPage.vue